module.exports = __webpack_public_path__ + "img/cancel-circle.18761bdf.svg";